import React from 'react';
import { Panel, PanelTheme } from '@apply/components';
import { NumberBoxPanel } from './components/NumberBoxPanel';
import { MoneyBoxPanel } from './components/MoneyBoxPanel';
import { DemoSection } from '../common/SectionNavigator';
import { DemoPage, DemoPageSection } from '../common/DemoLayout';

const sections: DemoSection[] = [
    { id: 'numberBoxDemo_numberbox', title: 'Number Box' },
    { id: 'numberBoxDemo_moneybox', title: 'Money Box' },
];

export const NumberBoxDemo: React.FC = () => {
    return (
        <DemoPage
            title='Number Box :'
            sections={sections}
        >
            <DemoPageSection id={sections[0].id}>
                <Panel theme={PanelTheme.White}>
                    <div style={{ padding: '1rem' }}>
                        <NumberBoxPanel />
                    </div>
                </Panel>
            </DemoPageSection>
            <DemoPageSection id={sections[1].id}>
                <Panel theme={PanelTheme.White}>
                    <div style={{ padding: '1rem' }}>
                        <MoneyBoxPanel />
                    </div>
                </Panel>
            </DemoPageSection>
        </DemoPage>
    );
};
